module.exports = __webpack_public_path__ + "static/media/dropdown-icon.5c5f0e5e.svg";